// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__13hhJ","col":"styles_col__2J-8U"};